import { FullSurveyInstance, SurveyResponseForCreate } from 'shared-components';
import { fetchApi } from './UserApi';

export default class SurveyInstanceService {
	public static getSurveyInstance = async (uuid: string, token: string) => {
		const res = await fetchApi<GetSurveyInstanceResponse>({
			route: 'survey/api',
			data: {
				action: 'getSurveyInstance',
				uuid,
				token,
			},
			errorMessage: 'Error fetching survey',
		});
		return res.data;
	};

	public static submitSurveyResponses = async (uuid: string, token: string, responses: SurveyResponseForCreate[]) => {
		const res = await fetchApi<SubmitSurveyResponsesResponse>({
			route: 'survey/api',
			data: {
				action: 'submitSurveyResponses',
				uuid,
				token,
				responses,
			},
			errorMessage: 'Error submitting survey',
		});
		return res.data;
	};
}

export type GetSurveyInstanceResponse =
	| {
			surveyInstance: FullSurveyInstance;
			error: null;
	  }
	| {
			surveyInstance: null;
			error: GetSurveyInstanceError;
	  };

export type GetSurveyInstanceError = 'SURVEY_INSTANCE_NOT_FOUND' | 'SURVEY_INSTANCE_EXPIRED' | 'SURVEY_RESPONDED';

export type SubmitSurveyResponsesResponse =
	| {
			success: true;
			message: string;
	  }
	| {
			success: false;
			message: string;
			error: SubmitSurveyResponsesError;
	  };

enum SubmitSurveyResponsesError {
	SURVEY_INSTANCE_NOT_FOUND,
	WRONG_SURVEY_INSTANCE,
	SURVEY_ALREADY_RESPONDED,
	INVALID_QUESTION_RESPONSE_TYPE,
}
